import type { TimeApi } from './adapter'
import { RealApi } from './real'

export const timeApi: TimeApi = new RealApi()

export type { TimeApi } from './adapter'
